import React from 'react'
import styled, { css } from 'styled-components'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import map from 'ramda/src/map'

import Typography from '../../../lib/typography'
import { parseFinancial } from '../../../lib/utils'

import { createTableCard } from '../../../components/project-profit-sheet/TableCard'
import IndicatorCost, * as IndicatorCostLayout from '../../../components/project-profit-sheet/IndicatorCost'

import { ppsSelector } from '../../../selectors'

import { determineColor, determineStatusColor } from '../model'

import { ABOVE_CURRENT_PRICE, WMD } from '../constants'

const BaseCard = createTableCard(css`
  grid-template-columns: repeat(7, calc(100% / 7));
`)

const Card = {
  ...BaseCard,
  Container: styled(BaseCard.Container)`
    height: 70px;
    padding-bottom: 12px;
    align-items: end;

    ${IndicatorCostLayout.Root} {
      width: 95%;
      margin-left: 8px;
      grid-column: span 3;
    }
  `,
}

/**
 * @param {object} props
 * @param {object} props.profitData
 */
function WManDayContainer({ profitData }) {
  const data = map(parseFinancial, {
    forecast: profitData[`$weighted_man_day_forecast`],
    actual: profitData[`$weighted_man_day_actual`],
    remaining: profitData[`$weighted_man_day_remaining`],
    initial: profitData[`$weighted_man_day_initial_plan`],
    gap: profitData[`$weighted_man_day_gap`],
  })

  const bars = [
    {
      value: data.actual,
      color: '#5cb85c',
      label: 'Actual WMD',
      formatter: { full: WMD },
    },
    {
      value: data.remaining,
      color: '#9be89b',
      label: 'Remaining WMD',
      formatter: { full: WMD },
    },
  ]

  const markers = [
    {
      value: data.initial,
      color: '#404040',
      type: 'solid',
      label: 'Approved Plan WMD',
      formatter: { abbr: WMD, full: WMD },
      trigger: ABOVE_CURRENT_PRICE,
    },
  ]

  return (
    <Card.Root topic="Service Weighted Man-days Summary">
      <Card.Heading>
        <Typography.Data>Forecast WMD</Typography.Data>
        <Typography.Data>Approved Plan WMD</Typography.Data>
        <Typography.Data style={ { paddingLeft: 8 } }>Progress</Typography.Data>
        <div />
        <div />
        <div />
        <Typography.Data title="Forecast - Approved Plan WMD">
          Forecast - Approved Plan WMD
        </Typography.Data>
      </Card.Heading>
      <Card.Container>
        <Typography.Data disc={ determineStatusColor(data) }>
          {data.forecast.toFixed(1)} WMDs
        </Typography.Data>
        <Typography.Data disc="black" weight="normal">
          {data.initial.toFixed(1)} WMDs
        </Typography.Data>
        <IndicatorCost threshold={ 0.05 } bars={ bars } markers={ markers } />
        <div />
        <Typography.Data weight="normal" color={ determineColor(data.gap) }>
          {data.gap.toFixed(1)} WMDs
        </Typography.Data>
      </Card.Container>
    </Card.Root>
  )
}

const mapStateToProps = createStructuredSelector({
  profitData: ppsSelector.profitData,
})

export default connect(mapStateToProps)(WManDayContainer)



// WEBPACK FOOTER //
// ./src/pages/project-profit-sheet/containers/WManDayContainer.js